<template>
    <div>
        <Dashboard/>
    </div>
</template>
<script>

    import Dashboard from '../dashboard/Dashboard'

    export default {
        name: 'manager-flow',
        components: {Dashboard},
    }
</script>